interface MiscState {
    hasAccessToCalendar: boolean;
}

export default {
    namespaced: true,
    state: {
        hasAccessToCalendar: false,
    } as MiscState,
    getters: {
        getHasAccessToCalendar: (state: MiscState) => () => state.hasAccessToCalendar,
    },
    mutations: {
        setHasAccessToCalendar(state: MiscState, hasAccessToCalendar: boolean) {
            state.hasAccessToCalendar = hasAccessToCalendar;
        },
        clear() {
            return {
                hasAccessToCalendar: false,
            };
        },
    },
};
